import { IRatingConfiguration } from "libraries/component/rating-table/rating-table.component";
import { EAirRatingDetailNames, EAirRatingDistributor } from "libraries/model/air-quote/IQuote";
import { EScaleColor, EScaleShape } from "libraries/component/rating-shape/rating-shape.component";

export const defaultRatingConfiguration : IRatingConfiguration = {
    distributor: EAirRatingDistributor.yucangoo,
    detailArray: [
        {
            code: EAirRatingDetailNames.topCarrier,
            nameArray: [
                {
                    languageCode: "fr",
                    value: "Top compagnie"
                },
                {
                    languageCode: "en",
                    value: "Top airline"
                }
            ],
            descriptionArray: [
                {
                    languageCode: "fr",
                    value: "Yucangoo se r\u00e9f\u00e8re \u00e0 un organisme de surveillances statistiques sur les voyages internationaux en vue de faire des classements des meilleures compagnies a\u00e9riennes."
                },
                {
                    languageCode: "en",
                    value: "Yucangoo refers to a statistical monitoring organization on international travel in order to obtain a ranking of the best airlines."
                }
            ],
            colorScaleArray: [
                {
                    min: 0,
                    max: 1,
                    color: EScaleColor.red,
                    shape: EScaleShape.round
                },
                {
                    min: 1,
                    max: 2,
                    color: EScaleColor.orange,
                    shape: EScaleShape.round
                },
                {
                    min: 2,
                    max: 3,
                    color: EScaleColor.yellow,
                    shape: EScaleShape.round
                },
                {
                    min: 3,
                    max: 5,
                    color: EScaleColor.green,
                    shape: EScaleShape.round
                }
            ]
        },
        {
            code: EAirRatingDetailNames.carbonFootprint,
            nameArray: [
                {
                    languageCode: "fr",
                    value: "\u00c9cologie"
                },
                {
                    languageCode: "en",
                    value: "Environment"
                }
            ],
            descriptionArray: [
                {
                    languageCode: "fr",
                    value: "Yucangoo calcule l'empreinte C02 lors du vol effectu\u00e9 en fonction de la classe dans laquelle le passager voyage."
                },
                {
                    languageCode: "en",
                    value: "Yucangoo calculates the C02 footprint of the flight according to the cabin class in which the passenger is traveling."
                }
            ],
            colorScaleArray: [
                {
                    min: 0,
                    max: 2,
                    color: EScaleColor.red,
                    shape: EScaleShape.round
                },
                {
                    min: 2,
                    max: 3,
                    color: EScaleColor.orange,
                    shape: EScaleShape.round
                },
                {
                    min: 3,
                    max: 5,
                    color: EScaleColor.green,
                    shape: EScaleShape.round
                }
            ]
        },
        {
            code: EAirRatingDetailNames.punctuality,
            nameArray: [
                {
                    languageCode: "fr",
                    value: "Ponctualit\u00e9"
                },
                {
                    languageCode: "en",
                    value: "On time performance"
                }
            ],
            descriptionArray: [
                {
                    languageCode: "fr",
                    value: "Yucangoo se base sur les informations d'une entreprise sp\u00e9cialis\u00e9e dans la r\u00e9cup\u00e9ration d'indemnit\u00e9s de d\u00e9dommagement a\u00e9riennes."
                },
                {
                    languageCode: "en",
                    value: "Yucangoo is based on information obtained from a company specialized in the recovery of air compensation."
                }
            ],
            colorScaleArray: [
                {
                    min: 0,
                    max: 1,
                    color: EScaleColor.red,
                    shape: EScaleShape.round
                },
                {
                    min: 1,
                    max: 2,
                    color: EScaleColor.orange,
                    shape: EScaleShape.round
                },
                {
                    min: 2,
                    max: 3,
                    color: EScaleColor.yellow,
                    shape: EScaleShape.round
                },
                {
                    min: 3,
                    max: 5,
                    color: EScaleColor.green,
                    shape: EScaleShape.round
                }
            ]
        },
        {
            code: EAirRatingDetailNames.routing,
            nameArray: [
                {
                    languageCode: "fr",
                    value: "Routing"
                },
                {
                    languageCode: "en",
                    value: "Routing"
                }
            ],
            descriptionArray: [
                {
                    languageCode: "fr",
                    value: "Yucangoo prend en compte le nombre d'escales, qui a un impact sur l'empreinte CO\u2082 (plus de consommation lors d'un d\u00e9collage et un atterrissage que lors du vol)."
                },
                {
                    languageCode: "en",
                    value: "Yucangoo takes into account the number of stopovers, which has an impact on the CO\u2082 footprint (more fuel consumption during a take-off and landing than during the flight)."
                }
            ],
            colorScaleArray: [
                {
                    min: 0,
                    max: 2,
                    color: EScaleColor.red,
                    shape: EScaleShape.round
                },
                {
                    min: 2,
                    max: 3,
                    color: EScaleColor.green,
                    shape: EScaleShape.round
                }
            ]
        }
    ]
};
